import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, LightbulbIcon, CalendarIcon, UsersIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function DashboardPage() {
  const navigate = useNavigate();
  const insights = [{
    title: 'Local Festival Coming Up',
    description: 'Street Food Festival in 5 days - perfect timing for promotion',
    icon: CalendarIcon,
    color: 'purple'
  }, {
    title: 'Weather Spike Opportunity',
    description: 'Sunny weekend forecast - ideal for outdoor seating posts',
    icon: TrendingUpIcon,
    color: 'blue'
  }, {
    title: 'Competitor Activity',
    description: '3 competitors posted about seasonal menu items',
    icon: UsersIcon,
    color: 'pink'
  }];
  const topIdeas = [{
    title: 'Pumpkin Spice Season Launch',
    engagement: 'High',
    hashtags: '#PumpkinSpice #FallVibes'
  }, {
    title: 'Local Business Collaboration',
    engagement: 'Medium',
    hashtags: '#ShopLocal #Community'
  }, {
    title: 'Behind-the-Scenes Coffee Roasting',
    engagement: 'High',
    hashtags: '#CoffeeLover #Artisan'
  }, {
    title: 'Customer Testimonial Feature',
    engagement: 'Medium',
    hashtags: '#HappyCustomers #Review'
  }, {
    title: 'Weekend Special Announcement',
    engagement: 'High',
    hashtags: '#WeekendVibes #SpecialOffer'
  }];
  return <div className="p-6 space-y-6" data-id="element-115">
      <div className="flex items-center justify-between" data-id="element-116">
        <div data-id="element-117">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white" data-id="element-118">
            Welcome back, Sarah
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1" data-id="element-119">
            Here's what's happening with your local marketing
          </p>
        </div>
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => navigate('/content-ideas')} className="px-6 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold flex items-center gap-2 shadow-lg shadow-purple-500/30" data-id="element-120">
          <SparklesIcon className="w-5 h-5" data-id="element-121" />
          Generate Ideas
        </motion.button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-122">
        {insights.map((insight, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: idx * 0.1
      }} whileHover={{
        y: -5
      }} className="p-6 rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 shadow-lg hover:shadow-xl transition-all" data-id="element-123">
            <div className={`w-12 h-12 rounded-xl bg-${insight.color}-100 dark:bg-${insight.color}-900/20 flex items-center justify-center mb-4`} data-id="element-124">
              <insight.icon className={`w-6 h-6 text-${insight.color}-600`} data-id="element-125" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-126">
              {insight.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-127">
              {insight.description}
            </p>
          </motion.div>)}
      </div>
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-lg p-6" data-id="element-128">
        <div className="flex items-center justify-between mb-6" data-id="element-129">
          <div className="flex items-center gap-2" data-id="element-130">
            <LightbulbIcon className="w-6 h-6 text-yellow-500" data-id="element-131" />
            <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-132">
              Top 5 Post Ideas This Week
            </h2>
          </div>
          <button onClick={() => navigate('/content-ideas')} className="text-purple-600 hover:text-purple-700 font-medium flex items-center gap-1" data-id="element-133">
            View All
            <ChevronRightIcon className="w-4 h-4" data-id="element-134" />
          </button>
        </div>
        <div className="space-y-3" data-id="element-135">
          {topIdeas.map((idea, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: idx * 0.1
        }} whileHover={{
          x: 5
        }} className="flex items-center justify-between p-4 rounded-xl border border-gray-200 dark:border-gray-800 hover:border-purple-300 dark:hover:border-purple-700 transition-all cursor-pointer" onClick={() => navigate('/post-composer')} data-id="element-136">
              <div className="flex-1" data-id="element-137">
                <h3 className="font-medium text-gray-900 dark:text-white mb-1" data-id="element-138">
                  {idea.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-139">
                  {idea.hashtags}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-140">
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${idea.engagement === 'High' ? 'bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400' : 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-400'}`} data-id="element-141">
                  {idea.engagement} Engagement
                </span>
                <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-142" />
              </div>
            </motion.div>)}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-143">
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={() => navigate('/post-composer')} className="p-6 rounded-2xl bg-gradient-to-br from-purple-500 to-blue-500 text-white text-left shadow-lg hover:shadow-xl transition-all" data-id="element-144">
          <h3 className="text-lg font-semibold mb-2" data-id="element-145">Create Post</h3>
          <p className="text-purple-100 text-sm" data-id="element-146">
            Design your next social media post
          </p>
        </motion.button>
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={() => navigate('/campaigns')} className="p-6 rounded-2xl bg-gradient-to-br from-pink-500 to-orange-500 text-white text-left shadow-lg hover:shadow-xl transition-all" data-id="element-147">
          <h3 className="text-lg font-semibold mb-2" data-id="element-148">New Campaign</h3>
          <p className="text-pink-100 text-sm" data-id="element-149">
            Plan your next marketing campaign
          </p>
        </motion.button>
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={() => navigate('/local-intelligence')} className="p-6 rounded-2xl bg-gradient-to-br from-green-500 to-teal-500 text-white text-left shadow-lg hover:shadow-xl transition-all" data-id="element-150">
          <h3 className="text-lg font-semibold mb-2" data-id="element-151">Local Insights</h3>
          <p className="text-green-100 text-sm" data-id="element-152">
            Discover opportunities in your area
          </p>
        </motion.button>
      </div>
    </div>;
}